import { httpRequest } from "../../http";

export type MoveFolderPayload = {
  folder_id: number;
  new_parent_id: number | null;
  new_index: number;
};

export class CommandMoveFolder {
  async run(payload: MoveFolderPayload) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/folders/move/`;

    try {
      const response = await httpRequest<any>(url, {
        method: "POST",
        body: payload,
      });
      return response;
    } catch (error) {
      console.error("Error moving folder:", error);
      throw error;
    }
  }
}
